import React from "react";
import sunLogo from "./sun.png";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  NavLink,
} from "react-router-dom";

export default function Navbar() {
  return (
    <div className="nav-div">
      <NavLink to="/">
        <img className="sun-icon" src={sunLogo} />
      </NavLink>
      <div
        style={{ marginLeft: "0", marginRight: "1rem", marginTop: "0.5rem" }}
      >
        <NavLink
          to="/"
          style={{
            textDecoration: "none",
            marginLeft: "1rem",
            color: "black",
            fontWeight: "bold",
          }}
        >
          Home
        </NavLink>
        <NavLink
          to="/internals"
          style={{
            textDecoration: "none",
            marginLeft: "1rem",
            color: "black",
            fontWeight: "bold",
          }}
        >
          Internals
        </NavLink>
        <NavLink
          to="/lifecycle"
          style={{
            textDecoration: "none",
            marginLeft: "1rem",
            color: "black",
            fontWeight: "bold",
          }}
        >
          Lifecycle
        </NavLink>
        <NavLink
          to="/about"
          style={{
            textDecoration: "none",
            marginLeft: "1rem",
            color: "black",
            fontWeight: "bold",
          }}
        >
          About
        </NavLink>
      </div>
      {/* <div className="icon-div" style={{ backgroundColor: "#78cdf5" }}> */}

      {/* </div> */}
    </div>
  );
}
